class RegimeTributarioService
  @$inject = ['genericServiceHelper']

  constructor: (serviceHelper) ->
    serviceHelper(
      url: '/eficiencia-fiscal/regime-tributario/'
      screenId: '#eficiencia-fiscal'
      service: this
      events:
        before:
          'save': (data) => @changeData(data)
          'update': (data) => @changeData(data)
    )

  changeData: (data) ->
    data.regimeTributarioReferencia = data.regimeTributarioReferencia.id
    data.cstPisEntradaDefault = data.cstPisEntradaDefault.id
    data.cstPisSaidaDefault = data.cstPisSaidaDefault.id
    data.cstCofinsEntradaDefault = data.cstCofinsEntradaDefault.id
    data.cstCofinsSaidaDefault = data.cstCofinsSaidaDefault.id
    return data

angular.module('eficienciaFiscalModule').service('efRegimeTributarioService', RegimeTributarioService)
